export default function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-hierarchy/src/hierarchy/sort.js
// module id = ./node_modules/d3-hierarchy/src/hierarchy/sort.js
// module chunks = vendor